var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "bg-dark", attrs: { id: "liveBoxContentTile" } },
    [
      _c(
        "div",
        { staticClass: "container-fluid pt-2 pt-md-3 pt-lg-4" },
        [
          _c("div", { staticClass: "row px-1 justify-content-center" }, [
            _c("div", { staticClass: "col-auto" }, [
              _c(
                "div",
                { staticClass: "d-flex justify-content-center text-center" },
                [
                  _c("h2", {
                    staticClass: "no-signature mb-0 text-white",
                    domProps: {
                      innerHTML: _vm._s(_vm.internetLiveBoxBlock.title),
                    },
                  }),
                ]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "row px-1 pt-2 justify-content-md-center" },
            [
              _c(
                "div",
                {
                  staticClass:
                    "col-12 col-lg-4 col-md-6 col-sm-6 p-0 pe-0 pe-md-1 pe-lg-2 pb-2 order-1 order-md-0 order-sm-0",
                },
                [
                  _vm.internetLiveBoxBlock.firstAttribute.icon
                    ? _c("p", {
                        staticClass: "icon text-white mb-0",
                        class: _vm.internetLiveBoxBlock.firstAttribute.icon,
                        staticStyle: { "font-size": "1.8rem" },
                        attrs: { "aria-hidden": "true" },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("h3", {
                    staticClass: "h4 mb-0 pt-0 text-primary",
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.internetLiveBoxBlock.firstAttribute.label
                      ),
                    },
                  }),
                  _vm._v(" "),
                  _c("p", {
                    staticClass: "mb-0 text-white",
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.internetLiveBoxBlock.firstAttribute.description
                      ),
                    },
                  }),
                ]
              ),
              _vm._v(" "),
              _vm.internetLiveBoxBlock.visual
                ? _c(
                    "div",
                    {
                      staticClass:
                        "col-12 col-lg-4 col-md-6 col-sm-6 p-0 pb-2 pb-1 order-0 order-md-1 order-sm-1 align-self-center text-center",
                    },
                    [
                      _c("img", {
                        staticClass: "img-fluid w-100",
                        attrs: {
                          src: _vm.internetLiveBoxBlock.visual.url,
                          alt: _vm.internetLiveBoxBlock.visual.alt,
                        },
                      }),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "col-12 col-lg-4 col-md-6 col-sm-6 p-0 ps-0 pe-md-1 pe-sm-1 ps-lg-2 pb-2 order-2",
                },
                [
                  _vm.internetLiveBoxBlock.secondAttribute.icon
                    ? _c("p", {
                        staticClass: "icon text-white mb-0",
                        class: _vm.internetLiveBoxBlock.secondAttribute.icon,
                        staticStyle: { "font-size": "1.8rem" },
                        attrs: { "aria-hidden": "true" },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("h3", {
                    staticClass: "h4 mb-0 pt-0 text-primary",
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.internetLiveBoxBlock.secondAttribute.label
                      ),
                    },
                  }),
                  _vm._v(" "),
                  _c("p", {
                    staticClass: "mb-0 text-white",
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.internetLiveBoxBlock.secondAttribute.description
                      ),
                    },
                  }),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "col-12 col-lg-4 col-md-6 col-sm-6 p-0 pb-2 order-3",
                },
                [
                  _vm.internetLiveBoxBlock.thirdAttribute.icon
                    ? _c("p", {
                        staticClass: "icon text-white mb-0",
                        class: _vm.internetLiveBoxBlock.thirdAttribute.icon,
                        staticStyle: { "font-size": "1.8rem" },
                        attrs: { "aria-hidden": "true" },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("h3", {
                    staticClass: "h4 mb-0 pt-0 text-primary",
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.internetLiveBoxBlock.thirdAttribute.label
                      ),
                    },
                  }),
                  _vm._v(" "),
                  _c("p", {
                    staticClass: "mb-0 text-white",
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.internetLiveBoxBlock.thirdAttribute.description
                      ),
                    },
                  }),
                ]
              ),
              _vm._v(" "),
              _vm._l(
                _vm.internetLiveBoxBlock.otherAttributes,
                function (otherAttr, otherIndex) {
                  return _c(
                    "div",
                    {
                      key: "other-" + otherIndex,
                      staticClass: "col-12 col-lg-4 col-md-6 col-sm-6 p-0 pb-2",
                      class: `order-${4 + otherIndex}`,
                    },
                    [
                      otherAttr.icon
                        ? _c("p", {
                            staticClass: "icon text-white mb-0",
                            class: otherAttr.icon,
                            staticStyle: { "font-size": "1.8rem" },
                            attrs: { "aria-hidden": "true" },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("h3", {
                        staticClass: "h4 mb-0 pt-0 text-primary",
                        domProps: { innerHTML: _vm._s(otherAttr.label) },
                      }),
                      _vm._v(" "),
                      _c("p", {
                        staticClass: "mb-0 text-white",
                        domProps: { innerHTML: _vm._s(otherAttr.description) },
                      }),
                    ]
                  )
                }
              ),
            ],
            2
          ),
          _vm._v(" "),
          _c("RepeaterBlock", {
            attrs: { "repeater-bloc-dto": _vm.repeaterBlocDto },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }